module.exports = __webpack_public_path__ + "static/media/noun_Left_406164.46e1de40.svg";